import k from '../kaboom'

export default function HelloWorld() {
  k.add([
    k.pos(k.width() * 0.5, k.height() * 0.5),
    k.text('Hello World!', { size: 55, align: 'center' }),
    k.color(255,255,255),
    k.anchor('center')
  ])
}